import { render, staticRenderFns } from "./tcustbase-add-or-updatee.vue?vue&type=template&id=2c9f7a6f&scoped=true&"
import script from "./tcustbase-add-or-updatee.vue?vue&type=script&lang=js&"
export * from "./tcustbase-add-or-updatee.vue?vue&type=script&lang=js&"
import style0 from "./tcustbase-add-or-updatee.vue?vue&type=style&index=0&id=2c9f7a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9f7a6f",
  null
  
)

export default component.exports